import { tApi } from 'tplus-api';
/**
 * 记前台系统级操作日志的API
 */
export default class SysLogApi {
    static async logWarn({logContent}) {
        return await tApi({
            logContent,
        }, 'chanjet.RE.Interface.INewRetail.LogWarn', false, false);
    }
    static async logError({logContent}) {
        return await tApi({
            logContent,
        }, 'chanjet.RE.Interface.INewRetail.LogError', false, false);
    }
}

